import axios from "axios";

export const fetchGetDetailTaskSubmit = async (id: string) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;

  return await axios.get(`${baseTaskUrl}/TaskSubmission/${id}`);
};
